
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { handleScrollReset } from '@/utils/navigationUtils';

interface BackToDashboardButtonProps {
  className?: string;
}

const BackToDashboardButton: React.FC<BackToDashboardButtonProps> = ({ 
  className = ''
}) => {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    navigate('/user/dashboard');
    handleScrollReset();
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleBackClick}
      className={`mb-4 flex items-center gap-2 ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      Back to Dashboard
    </Button>
  );
};

export default BackToDashboardButton;
